import { render, staticRenderFns } from "./index-list.vue?vue&type=template&id=540c9962&scoped=true&"
import script from "./index-list.vue?vue&type=script&lang=js&"
export * from "./index-list.vue?vue&type=script&lang=js&"
import style0 from "./index-list.vue?vue&type=style&index=0&id=540c9962&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540c9962",
  null
  
)

export default component.exports